import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import UserOutline from './user-outline-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <UserOutline {...validProps} />;
}

SvgComponent.iconName = 'user-outline';

export const UserOutlineIcon = svgIconWrapper(SvgComponent);
